import {all, put, takeLatest} from 'redux-saga/effects';
import {menuChangeState} from './actions'

export function* changeState({action, payload}){
	yield put(menuChangeState())
}

export default all([takeLatest('@menu/CHANGE_STATE', changeState)])